import { render, staticRenderFns } from "./ShadowBanButton.vue?vue&type=template&id=ca5d7e76&scoped=true&"
import script from "./ShadowBanButton.vue?vue&type=script&lang=js&"
export * from "./ShadowBanButton.vue?vue&type=script&lang=js&"
import style0 from "./ShadowBanButton.vue?vue&type=style&index=0&id=ca5d7e76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5d7e76",
  null
  
)

export default component.exports